export default __webpack_public_path__ + "static/media/whitedotted.fa55ec1c.svg";